import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { HelpHint } from "@/components/HelpHint";

// Settings -> Presentation Mode tab. Extracted from Settings.js (props-driven,
// no behavior change).
export const PresentationModeSection = ({ demoCta, onChange, onSave, saving }) => (
  <div className="space-y-4" data-testid="presentation-mode-section">
    <div className="flex items-center gap-1.5">
      <h2 className="font-heading text-lg font-semibold">Presentation Mode</h2>
      <HelpHint text="Prospects can explore a read-only Showcase Edition at /demo using sample data. Configure where the 'View Business Systems' button sends them." testId="presentation-mode-help" />
    </div>
    <p className="text-sm text-muted-foreground max-w-md">
      Set the external link (e.g. your business website) used by the Presentation Mode banner&apos;s
      &quot;View Business Systems&quot; button. Leave blank to show a friendly contact message instead.
    </p>
    <div className="space-y-1.5 max-w-md">
      <Label>View Business Systems URL (optional)</Label>
      <Input
        placeholder="https://815digitalservices.com/"
        value={demoCta.url}
        onChange={(e) => onChange({ url: e.target.value })}
        data-testid="demo-cta-url-input"
      />
    </div>
    <div className="pt-2 border-t">
      <Button onClick={onSave} disabled={saving} className="bg-[hsl(var(--role-accent))] hover:opacity-95" data-testid="demo-cta-save-button">
        {saving ? "Saving..." : "Save Changes"}
      </Button>
    </div>
  </div>
);
